"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _link = _interopRequireDefault(require("@waglabs/link"));

var _text = _interopRequireDefault(require("@waglabs/text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SidebarItem = function SidebarItem(_ref) {
  var route = _ref.route;
  return _react["default"].createElement(_link["default"], {
    href: route.url
  }, _react["default"].createElement(_text["default"], {
    hover: true,
    color: "medGray",
    fontFamily: "body",
    ml: 3
  }, route.label));
};

exports.SidebarItem = SidebarItem;